import request from '@/utils/request'
import URL from './urlTranslator'

export function login(data) {
  return request({
    url: '/user/login',
    method: 'post',
    data
  })
}

export function changePassword(oldPwd, newPwd) {
  return request({
    url: URL.sys.changePassword,
    method: 'get',
    params: { oldPwd, newPwd }
  })
}

export function getInfo(token) {
  return request({
    url: '/user/info',
    method: 'get',
    params: { token }
  })
}

export function logout() {
  return request({
    url: '/user/logout',
    method: 'post'
  })
}

export function getUserList(params) {
  return request({
    url: URL.sys.sysUser,
    method: 'get',
    params
  })
}

export function getAllUsers(params) {
  return request({
    url: URL.sys.getAllUserUrl,
    method: 'get',
    params
  })
}

export function getDropdownUser(params) {
  return request({
    url: URL.common.dropDown.user,
    method: 'get',
    params
  })
}

/**
 * 查询cargo数据库对应的用户
 * @param userId
 */
export function getUserByUserId(userId) {
  return request({
    url: `${URL.sys.queryUser}/${userId}`,
    method: 'get'
  })
}

export function getUserById(id) {
  return request({
    url: `${URL.sys.sysUser}/${id}`,
    method: 'get'
  })
}

export function getUserUrl(id) {
  return request({
    url: `${URL.sys.getUserUrl}/${id}`,
    method: 'get'
  })
}

export function saveUser(data) {
  return request({
    url: URL.sys.sysUser,
    method: 'post',
    data
  })
}

export function editUser(data) {
  return request({
    url: URL.sys.sysUser,
    method: 'put',
    data
  })
}

export function updatePersonalInfo(data) {
  return request({
    url: URL.sys.updatePersonalInfo,
    method: 'post',
    data
  })
}

export function batchUpdateUser(data) {
  return request({
    url: URL.sys.batchUpdateUser,
    method: 'post',
    data
  })
}

export function updatePersonalEmail(data) {
  return request({
    url: URL.sys.updatePersonalEmail,
    method: 'post',
    data
  })
}

export function getPersonalEmail(data) {
  return request({
    url: URL.sys.getPersonalEmail,
    method: 'post',
    data
  })
}

export function getMailTemplateByParams(data) {
  return request({
    url: URL.sys.getMailTemplateByParams,
    method: 'post',
    data
  })
}

export function checkMailTemplateExist(templateName) {
  return request({
    url: URL.sys.checkMailTemplateExist,
    method: 'post',
    params: { templateName }
  })
}

export function saveMailboxTemplate(data) {
  return request({
    url: URL.sys.saveMailboxTemplate,
    method: 'post',
    data
  })
}
export function personalSendTest(data) {
  return request({
    url: URL.sys.personalSendTest,
    method: 'post',
    data
  })
}

export function templateSendTest(data) {
  return request({
    url: URL.sys.templateSendTest,
    method: 'post',
    data
  })
}

export function deleteMailTemplate(data) {
  return request({
    url: URL.sys.batchDeleteUrl,
    method: 'post',
    data
  })
}

export function activeUser(data) {
  return request({
    url: URL.sys.activeSysUser,
    method: 'put',
    data
  })
}

export function activateUser(id) {
  return request({
    url: `${URL.sys.userEnable}`,
    method: 'put',
    params: { id }
  })
}

export function deactivateUser(id) {
  return request({
    url: `${URL.sys.userDisable}`,
    method: 'put',
    params: { id }
  })
}

export function getOffice() {
  return request({
    url: `${URL.sys.officeList}`,
    method: 'get'
  })
}

export function getUserOfficeList() {
  return request({
    url: `${URL.sys.userOfficeList}`,
    method: 'get'
  })
}

export function getOfficeConfigList(params) {
  return request({
    url: `${URL.sys.officeConfigList}`,
    method: 'get',
    params
  })
}

export function getOfficeConfigByName(params) {
  return request({
    url: URL.sys.officeConfigByName,
    method: 'get',
    params
  })
}

export function saveOfficeConfig(data) {
  return request({
    url: URL.sys.saveOfficeConfig,
    method: 'post',
    data
  })
}
export function saveOfficeConfigFunc(data) {
  return request({
    url: URL.sys.saveOfficeConfigUrl,
    method: 'post',
    data
  })
}
// 复制分公司配置
export function copyOfficeConfigUrl(data, branchIds) {
  return request({
    url: URL.sys.copyOfficeConfigUrl + '?branchIds=' + branchIds,
    method: 'post',
    data
  })
}
// 验证规则名称
export function validConfig(params) {
  return request({
    url: URL.sys.validConfig,
    method: 'get',
    params
  })
}
// 验证规则名称
export function deleteConfig(params) {
  return request({
    url: URL.sys.detail,
    method: 'delete',
    params
  })
}

export function saveOrUpdateConfig(data) {
  return request({
    url: URL.sys.saveOrUpdateConfig,
    method: 'post',
    data
  })
}
export function searchConfig(params) {
  return request({
    url: URL.sys.searchConfig,
    method: 'get',
    params
  })
}
export function searchConfigMap(params) {
  return request({
    url: URL.sys.searchConfigMap,
    method: 'get',
    params
  })
}

export function getDepartment() {
  return request({
    url: `${URL.sys.departmentList}`,
    method: 'get'
  })
}

export function getDepartmentByOfficeId(officeId) {
  return request({
    url: `${URL.sys.departmentList}`,
    method: 'get',
    params: { officeId }
  })
}

export function getUserDepartmentTeam(params) {
  return request({
    url: `${URL.sys.userDepartmentTeam}`,
    method: 'get',
    params
  })
}

export function getUserDepartmentTeamNew(departmentKeys, branchId) {
  return request({
    url: `${URL.sys.userDepartmentTeamNew}`,
    method: 'post',
    data: departmentKeys,
    params: { branchId }
  })
}

// 获取同组部门及下级部门下的用户ID列表（含子部门）
export function getUserDepartmentTeamWithChild(data) {
  return request({
    url: URL.sys.getUserByDepartmentKeysWithChild,
    method: 'post',
    data
  })
}

// 获取多个部门下所有的用户
export function getAllUsersByDepartments(departmentKeys) {
  return request({
    url: URL.sys.getAllUsersByDepartments,
    method: 'post',
    data: departmentKeys
  })
}

export function getAssignedRole(id) {
  return request({
    url: `${URL.sys.userAssignedRole}/${id}`,
    method: 'get'
  })
}

export function saveAssignedRole(data) {
  return request({
    url: `${URL.sys.userAssignRole}`,
    method: 'post',
    data
  })
}

export function getAssignedRule(id) {
  return request({
    url: `${URL.sys.userAssignedRule}/${id}`,
    method: 'get'
  })
}

export function saveAssignedRule(data) {
  return request({
    url: `${URL.sys.userAssignRule}`,
    method: 'post',
    data
  })
}

export function resetPassword(userId) {
  return request({
    url: `${URL.sys.resetPassword}/${userId}`,
    method: 'put'
  })
}
//
// export function changePassword(data) {
//   return request({
//     url: `${URL.sys.changePassword}`,
//     method: 'post',
//     data
//   })
// }

export function getOfficeUserList(officeId) {
  return request({
    url: `${URL.sys.officeUserList}`,
    method: 'get',
    params: { officeId }
  })
}
export function getUserListByRoleUuid(roleUuid) {
  return request({
    url: `${URL.sys.userList4RoleUuid}`,
    method: 'get',
    params: { roleUuid }
  })
}

export function getUserListForRole() {
  return request({
    url: `${URL.sys.userListForRole}`,
    method: 'get'
  })
}

export function getUserDefaultDepartment(params) {
  return request({
    url: URL.sys.getUserDefaultDepartment,
    method: 'get',
    params
  })
}

// 根据权限类，权限型，用户ID, 分公司，获取默认部门。
export function getUserDefaultDepartmentByOffice(params) {
  return request({
    url: URL.sys.getUserDefaultDepartmentByOffice,
    method: 'get',
    params
  })
}

export function getUserDepartmentOffices(params) {
  return request({
    url: URL.sys.getUserDepartmentOffices,
    method: 'get',
    params
  })
}

export function getUserDeptOffices(params) {
  return request({
    url: URL.sys.getUserDeptOffices,
    method: 'get',
    params
  })
}

export function getUserList4NoRole() {
  return request({
    url: `${URL.sys.userList4NoRole}`,
    method: 'get'
  })
}

export function addUser2Role(data, type) {
  let url = `${URL.sys.addUser2Role}`
  if (type === 'dept') {
    url = `${URL.sys.addDeptUser2Role}`
  } else if (type === 'office') {
    url = `${URL.sys.addOfficeUser2Role}`
  }
  return request({
    url: url,
    method: 'post',
    data
  })
}

export function delUser2Role(data) {
  return request({
    url: `${URL.sys.delUser2Role}`,
    method: 'put',
    data
  })
}

export function getUserDepartmentGroup(params) {
  return request({
    url: `${URL.sys.getUserDepartmentGroup}`,
    method: 'get',
    params
  })
}

export function getUsersByPrivilegeDetail(params) {
  return request({
    url: `${URL.sys.getUsersByPrivilegeDetail}`,
    method: 'get',
    params
  })
}

// 获取指定权限下面的用户（合并多个请求）
export function getUsersByPrivilegeDetailByMerge(data) {
  return request({
    url: URL.sys.getUsersByPrivilegeDetailByMerge,
    method: 'post',
    data
  })
}

export function getDepIdAndOffIdByUserOrDep(params) {
  return request({
    url: URL.sys.getDepIdAndOffIdByUserOrDep,
    method: 'get',
    params
  })
}

// 获取该公司下所有的用户
export function getAllUsersByOffice(params) {
  return request({
    url: URL.sys.getAllUsersByOffice,
    method: 'get',
    params
  })
}

export function querySysBsDebtsNotify() {
  return request({
    url: URL.sys.querySysBsDebtsNotify,
    method: 'get'
  })
}

/**
 * 获得userId的所有有某权限的下属,包括userId本人
 * @param userId
 */
export function getJuniorSales(userId) {
  return request({
    url: URL.sys.getJuniorSales,
    method: 'get',
    params: { userId }
  })
}

// 获取用户下的所有权限
export function getAllPrivilegeByUserId(params) {
  return request({
    url: URL.sys.getAllPrivilegeByUserId,
    method: 'get',
    params
  })
}

// 根据指定的权限获取用户所有的角色以及角色关联的部门信息
export function getUserRoleByPrivilege(data) {
  return request({
    url: URL.sys.getUserRoleByPrivilege,
    method: 'post',
    data
  })
}

// 获取公众号个人关注二维码
export function queryQrCode(data) {
  return request({
    url: URL.sys.queryQrCode,
    method: 'post',
    data
  })
}

// 根据租户id、公司ids获取用户list
export function getUserByTenantIdAndOfficeIds(params) {
  return request({
    url: `${URL.sys.getUserByTenantIdAndOfficeIds}`,
    method: 'get',
    params
  })
}

// 获取后端配置文件配置
export function getProperties(data) {
  return request({
    url: URL.sys.getProperties,
    method: 'post',
    data
  })
}

export function updateTrackingTemplateUuids(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.sys.updateTrackingTemplateUuids,
    method: 'post',
    data
  })
}

export function updateTrackingTemplateUuidsWt(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.sys.updateTrackingTemplateUuidsWt,
    method: 'post',
    data
  })
}

export function queryAllConfig(data) {
  return request({
    url: URL.sys.queryAllConfig,
    method: 'post',
    data
  })
}

export function getCargoAllUser(data) {
  return request({
    url: URL.sys.getAllUser,
    method: 'post',
    data
  })
}

export function getUserWarning() {
  return request({
    url: URL.sys.getUserWarning,
    method: 'get'
  })
}

export function saveUserWarning(data) {
  return request({
    url: URL.sys.saveUserWarning,
    method: 'post',
    data
  })
}

export function getThirdUserListFunc(data) {
  return request({
    url: URL.sys.getThirdUserListUrl,
    method: 'post',
    data
  })
}
